import {ChangeDetectorRef, Component, inject, viewChild, ViewChild, ViewEncapsulation} from '@angular/core';
import {BaseControlComponent, EmailTemplateFormService, EsvgFiles} from 'frontier/nucleus';
import {FormApiAdapter, FormWrapperComponent, IForm, IKeyToStyleMap} from 'frontier/browserkit';
import {combineLatest, concatMap, Subscription} from "rxjs";
import {FormControl} from "@angular/forms";
import LibControlGuids from 'frontier/nucleus/src/lib/apiv2/ControlGuids';
import {toObservable} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs/operators';

class MailTemplateApiAdapter extends FormApiAdapter {
  override styles: IKeyToStyleMap = {
    ['Name;-1']: {
      // icon: EsvgFiles.user,
      // cssClass: 'red-background'
    },
    ['Content;-1']: {
      textAreaInitialRowCount: 7,
    }
  }

  override from(apiData: IForm): IForm {
    // 'Ersetzungsfelder' isn't needed anymore and should therefore no longer be displayed.
    apiData.formGroups[0].elements = apiData.formGroups[0].elements.slice(0, 2);
    return super.from(apiData);
  }

  override to(data: any): any {
    return null;
  }
}

@Component({
  selector: 'lib-mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    FormWrapperComponent
  ],
  standalone: true
})
export class MailTemplateComponent {
  private _emailTemplateService = inject(EmailTemplateFormService)
  protected readonly EsvgFiles = EsvgFiles;

  @ViewChild('form') form: FormWrapperComponent;
  controlRef = viewChild(BaseControlComponent);
  controlRef$ = toObservable(this.controlRef);
  subs = new Subscription();
  selectFormControl = new FormControl(null);

  eMailGuid = LibControlGuids.TEmailTemplateForm;
  apiAdapter = new MailTemplateApiAdapter();
  displayedText = '';

  constructor(
    protected cdr: ChangeDetectorRef,
  ) {
    this.subs.add(
      combineLatest([
        this.selectFormControl.valueChanges,
        this.controlRef$.pipe(
          filter(controlRef => controlRef != null),
          concatMap((controlRef: BaseControlComponent) => controlRef.apiInstanceInitialize)
        )])
        .subscribe(([v, apiInstance]) => {
          if (!apiInstance || !v) {
            return;
          }
          this.displayedText = '';
          if (v) {
            this.controlRef().apiInstance.filter = {...this.controlRef().apiInstance.filter, parent: v};
            this.controlRef().changeAndFetch().subscribe();
          }
        })
    )
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }


  refresh() {
    this.controlRef().changeAndFetch().subscribe();
  }

  deleteTemplate(): void {
    this.form.formRepositorySelection().deleteElementClicked(this.form.selectFormControl.value);
    this.selectFormControl.patchValue(null);
  }
}
